module.exports = __webpack_public_path__ + "static/media/IMG_5414 - Version 2.fbd7be0c.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/IMG_5414 - Version 2.JPG
// module id = 530
// module chunks = 0